import { DataGrid } from "@msuite/ui/data-grid";
import { useTranslation } from "@msuite/ui/localization";
import { Weekdays } from "@msuite/ui/weekday-picker";
import { getVacationDaysAccrualTypeTranslationKey } from "@msuite/utils/absences";
import { moment } from "@msuite/utils/date";
import { getRegionTranslationKey } from "@msuite/utils/misc";
import { formatNumber } from "@msuite/utils/numbers";
import { guardString } from "@msuite/utils/strings";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface UserEmploymentItemProps {
	employment: Tables<"employments">;
}

export function UserEmploymentItem({ employment }: UserEmploymentItemProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<DataGrid>
			<DataGrid.Row>
				<DataGrid.Label>{t("personnel.employment.job_title")}</DataGrid.Label>
				<DataGrid.Value>{guardString(employment.jobTitle)}</DataGrid.Value>
			</DataGrid.Row>
			<DataGrid.Row>
				<DataGrid.Label>{t("misc.regions.region")}</DataGrid.Label>
				<DataGrid.Value>{t(getRegionTranslationKey(employment.region))}</DataGrid.Value>
			</DataGrid.Row>
			<DataGrid.Divider />
			<DataGrid.Row>
				<DataGrid.Label>{t("personnel.employment.valid_from")}</DataGrid.Label>
				<DataGrid.Value>{moment(employment.validFrom).dateFormat()}</DataGrid.Value>
			</DataGrid.Row>
			<DataGrid.Row>
				<DataGrid.Label>{t("personnel.employment.valid_to")}</DataGrid.Label>
				<DataGrid.Value>
					{employment.validTo ? moment(employment.validTo).dateFormat() : guardString(null)}
				</DataGrid.Value>
			</DataGrid.Row>
			<DataGrid.Divider />
			<DataGrid.Row>
				<DataGrid.Label>{t("personnel.employment.hours_per_week")}</DataGrid.Label>
				<DataGrid.Value>{formatNumber(employment.hoursPerWeek, "hour")}</DataGrid.Value>
			</DataGrid.Row>
			<DataGrid.Row>
				<DataGrid.Label>{t("absences.vacation_days")}</DataGrid.Label>
				<DataGrid.Value>{formatNumber(employment.vacationDays, "day")}</DataGrid.Value>
			</DataGrid.Row>
			<DataGrid.Row>
				<DataGrid.Label>{t("absences.accrual_type.accrual_type")}</DataGrid.Label>
				<DataGrid.Value>
					{t(getVacationDaysAccrualTypeTranslationKey(employment.vacationDaysAccrualType))}
				</DataGrid.Value>
			</DataGrid.Row>
			<DataGrid.Row>
				<DataGrid.Label>{t("dates.weekdays")}</DataGrid.Label>
				<DataGrid.Cell>
					<Weekdays
						isReadonly
						size="xs"
						selectedDays={employment.workdays}
					/>
				</DataGrid.Cell>
			</DataGrid.Row>
			<DataGrid.Divider />
		</DataGrid>
	);
}
